import { render, staticRenderFns } from "./product.vue?vue&type=template&id=7f51e914"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/var/app/staging/components/LoadingSpinner.vue').default,BreadcrumbsNavigation: require('/var/app/staging/components/BreadcrumbsNavigation.vue').default,ReviewStars: require('/var/app/staging/components/ReviewStars.vue').default,DropdownSelector: require('/var/app/staging/components/DropdownSelector.vue').default,ProductPackSizeSwitcher: require('/var/app/staging/components/ProductPackSizeSwitcher.vue').default,ImageCarousel: require('/var/app/staging/components/ImageCarousel.vue').default,ProductPrescription: require('/var/app/staging/components/ProductPrescription.vue').default,AccordionContainer: require('/var/app/staging/components/AccordionContainer.vue').default,ProductReviews: require('/var/app/staging/components/ProductReviews.vue').default,AuthorBlock: require('/var/app/staging/components/AuthorBlock.vue').default,RecommendationCarousel: require('/var/app/staging/components/RecommendationCarousel.vue').default,ModalDialogRecommendations: require('/var/app/staging/components/ModalDialogRecommendations.vue').default})
